import {
  SPONSORSINSIGHT_NOOFSPON,
  SPONSORSINSIGHT_SPONLISTVIEW,
  SPONSORSINSIGHT_SPONPROFVIEW,
  SPONSORSINSIGHT_SPONSEARCH,
  SPONSORSINSIGHT_SPONFAVO,
  SPONSORSINSIGHT_ITEM_SELECTED,
  SPONSORSINSIGHT_MOSTSEARKEYS_TABLELIST,
  SPONSORSINSIGHT_TOPSPON_TABLELIST,
  SPONSORSINSIGHT_ENGAGEMENT_BARCHART,
} from "SponsorinsightActions";

export var SponsorInsightMenu = (state = [], action) => {
  //iconName is optional
  var state = [
    {
      key: SPONSORSINSIGHT_NOOFSPON,
      iconName: "noofspon",
      sectionName: "Number of sponsors",
      sectionDesc: "How many sponsors are there in the event",
      selected: false,
    },
    {
      key: SPONSORSINSIGHT_SPONLISTVIEW,
      iconName: "sponlistview",
      sectionName: "Sponsor's list views",
      sectionDesc: "Number of user who browsed through the sponsors list",
      selected: false,
    },
    {
      key: SPONSORSINSIGHT_SPONPROFVIEW,
      iconName: "sponprofview",
      sectionName: "Sponsor's profile views",
      sectionDesc: "Number of user who browsed through the sponsor's profiles",
      selected: false,
    },
    {
      key: SPONSORSINSIGHT_SPONSEARCH,
      iconName: "sponsearch",
      sectionName: "Sponsor searches",
      sectionDesc: "Number of searches done on Sponsor list",
      selected: false,
    },
    {
      key: SPONSORSINSIGHT_SPONFAVO,
      iconName: "sponfavo",
      sectionName: "Sponsor favourites",
      sectionDesc: "Number of bookmarked sponsor profiles",
      selected: false,
    },
  ];

  var index = 0;
  state[index].selected = true;

  return state;
};

// Initial select tab is "SPONSORSINSIGHT_NOOFSPON"
export var SponsorsinsightSelectedItem = (
  state = SPONSORSINSIGHT_NOOFSPON,
  action
) => {
  if (action.type == SPONSORSINSIGHT_ITEM_SELECTED) {
    state = action.payload.key;
  }

  return state;
};

// Local reducers for most search keywords related to sponsors netword
export var SponsorsinsightMostsearkeysTablelist = (state = {}, action) => {
  switch (action.type) {
    case SPONSORSINSIGHT_MOSTSEARKEYS_TABLELIST:
      return action.data;
    default:
      return state;
  }
};

// Local reducers for sponsors profiles with most user engagement
export var SponsorsinsightTopsponTablelist = (state = {}, action) => {
  switch (action.type) {
    case SPONSORSINSIGHT_TOPSPON_TABLELIST:
      return action.data;
    default:
      return state;
  }
};

// Local reducer for {Sponsors Engagement (Chart view of how actively the sponsor feature has been use over the selected date range)}

export const SponsorsinsightEngagementbarChart = (state = {}, action) => {
  switch (action.type) {
    case SPONSORSINSIGHT_ENGAGEMENT_BARCHART:
      return action.payload;
      break;
    default:
      return state;
      break;
  }
};
